import { colors } from './colors'

export const globals = {
  colors,
}
